import { Flex, LoaderTalos, Text } from '@talos/kyoko';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import type { RFQSweepingPanelConfig } from '../../../../types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';
import { RFQSweepingPanelContent } from '../../../OMS/NewRFQ/QuoteSweeping/RFQSweepingPanelContent';
import { useRFQSweepingPanelData } from '../../../OMS/NewRFQ/QuoteSweeping/useRFQSweepingPanelData';
import type { LayoutPanelProps } from '../../types';

export function RFQSweepingPanel({ api, params }: LayoutPanelProps<RFQSweepingPanelConfig>) {
  const { enableRFQSweeping } = useFeatureFlag();
  const { panelData, isLoading, missingParentOrderID } = useRFQSweepingPanelData(
    enableRFQSweeping ? params.sweepGroupID : undefined
  );

  if (!enableRFQSweeping) {
    return (
      <Panel panelApi={api} data-testid="rfq-sweeping-panel">
        <Flex alignItems="center" justifyContent="center" h="100%">
          <Text>RFQ sweeping is not enabled.</Text>
        </Flex>
      </Panel>
    );
  }

  // We have a few different states we want to portray to the user in case we are loading, or anything goes wrong...
  return (
    <Panel panelApi={api} data-testid="rfq-sweeping-panel">
      {!params.sweepGroupID ? (
        <Flex alignItems="center" justifyContent="center" h="100%">
          <Text>No SweepGroupID found in Panel. Please remove the panel and try again.</Text>
        </Flex>
      ) : isLoading ? (
        <Flex alignItems="center" justifyContent="center" h="100%">
          <LoaderTalos />
        </Flex>
      ) : missingParentOrderID ? (
        <Flex alignItems="center" justifyContent="center" h="100%" data-testid="rfq-sweeping-panel-parent-missing">
          <Text>Expected to find a care order for {missingParentOrderID}, but was unable to.</Text>
        </Flex>
      ) : panelData ? (
        <RFQSweepingPanelContent key={params.sweepGroupID} {...panelData} onClose={api.close} />
      ) : (
        <Flex alignItems="center" justifyContent="center" h="100%">
          <Text>Unable to load RFQ sweeping panel.</Text>
        </Flex>
      )}
    </Panel>
  );
}
